import React, { useEffect, useState } from 'react';
import AdminApi from './AdminApi';

// 3 vai trò chuẩn (feature 002) — dùng hệ auth thật a_account.role
const ROLE_OPTIONS = [
    { value: 'ADMIN', label: 'Admin — toàn quyền' },
    { value: 'MAKER', label: 'Maker — đăng bài & nội dung' },
    { value: 'CHECKER', label: 'Checker — duyệt bài' },
];

const AdminAccountEditPage = ({ clickChangeMenu }) => {
    const [formData, setFormData] = useState({
        username: '',
        password: '',
        confirmPassword: '',
        name: '',
        address: '',
        role: 'MAKER'
    });
    const [isLoading, setIsLoading] = useState(false);
    const [message, setMessage] = useState(null);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({ ...prev, [name]: value }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setMessage(null);
        if (!formData.username || !formData.password) {
            setMessage({ type: 'error', text: 'Vui lòng nhập tên đăng nhập và mật khẩu.' });
            return;
        }
        if (formData.password.length < 6) {
            setMessage({ type: 'error', text: 'Mật khẩu phải có ít nhất 6 ký tự.' });
            return;
        }
        if (formData.password !== formData.confirmPassword) {
            setMessage({ type: 'error', text: 'Mật khẩu xác nhận không khớp.' });
            return;
        }

        setIsLoading(true);
        const res = await AdminApi.registerAccount({
            username: formData.username,
            password: formData.password,
            name: formData.name,
            address: formData.address,
            role: formData.role
        });
        setIsLoading(false);
        if (res.ok) {
            setMessage({ type: 'success', text: 'Tạo tài khoản thành công!' });
            setTimeout(() => clickChangeMenu('taikhoan'), 1000);
        } else {
            const m = res.data && (res.data.message || (res.data.body && res.data.body.message));
            setMessage({ type: 'error', text: m || (res.status === 403 ? 'Bạn không đủ quyền tạo tài khoản.' : 'Lỗi khi tạo tài khoản (tên đăng nhập có thể đã tồn tại).') });
        }
    };

    return (
        <div className="social-box" style={{ padding: '20px', backgroundColor: 'white', borderRadius: '8px', margin: '15px' }}>
            <h3 className="page-title" style={{ marginBottom: '20px', borderBottom: '1px solid #eee', paddingBottom: '10px' }}>Tạo Tài khoản</h3>

            {message && (
                <div style={{
                    padding: '10px 14px', borderRadius: '8px', marginBottom: '16px', maxWidth: '520px', fontWeight: 600,
                    background: message.type === 'success' ? '#e7f6ec' : '#fdecec',
                    color: message.type === 'success' ? '#1c8c3c' : '#cf383d',
                    border: `1px solid ${message.type === 'success' ? '#bfe5cb' : '#f5c6c6'}`
                }}>{message.text}</div>
            )}

            <form onSubmit={handleSubmit} className="form-horizontal" style={{ marginTop: '20px' }}>
                <div className="control-group">
                    <label className="control-label" style={{ width: '200px' }}>Đăng nhập</label>
                    <div className="controls" style={{ marginLeft: '220px' }}>
                        <input type="text" name="username" value={formData.username} onChange={handleChange} className="span6" required />
                    </div>
                </div>

                <div className="control-group" style={{ marginTop: '15px' }}>
                    <label className="control-label" style={{ width: '200px' }}>Họ tên</label>
                    <div className="controls" style={{ marginLeft: '220px' }}>
                        <input type="text" name="name" value={formData.name} onChange={handleChange} className="span6" />
                    </div>
                </div>

                <div className="control-group" style={{ marginTop: '15px' }}>
                    <label className="control-label" style={{ width: '200px' }}>Địa chỉ / Email</label>
                    <div className="controls" style={{ marginLeft: '220px' }}>
                        <input type="text" name="address" value={formData.address} onChange={handleChange} className="span6" />
                    </div>
                </div>

                <div className="control-group" style={{ marginTop: '15px' }}>
                    <label className="control-label" style={{ width: '200px' }}>Mật khẩu</label>
                    <div className="controls" style={{ marginLeft: '220px' }}>
                        <input type="password" name="password" value={formData.password} onChange={handleChange} className="span6" required />
                    </div>
                </div>

                <div className="control-group" style={{ marginTop: '15px' }}>
                    <label className="control-label" style={{ width: '200px' }}>Mật khẩu Xác nhận</label>
                    <div className="controls" style={{ marginLeft: '220px' }}>
                        <input type="password" name="confirmPassword" value={formData.confirmPassword} onChange={handleChange} className="span6" required />
                    </div>
                </div>

                <div className="control-group" style={{ marginTop: '15px' }}>
                    <label className="control-label" style={{ width: '200px' }}>Vai trò</label>
                    <div className="controls" style={{ marginLeft: '220px' }}>
                        <select name="role" className="span6" value={formData.role} onChange={handleChange}>
                            {ROLE_OPTIONS.map(r => (
                                <option key={r.value} value={r.value}>{r.label}</option>
                            ))}
                        </select>
                    </div>
                </div>

                <div className="form-actions" style={{ backgroundColor: '#f9f9f9', borderTop: '1px solid #eee', padding: '15px 220px', marginTop: '30px', marginLeft: '-20px', marginRight: '-20px', borderRadius: '0 0 8px 8px' }}>
                    <button type="submit" className="btn btn-primary" style={{ backgroundColor: '#5cb85c', border: 'none', padding: '6px 20px' }} disabled={isLoading}>
                        {isLoading ? 'Đang xử lý...' : 'Tạo'}
                    </button>
                    <button type="button" className="btn" style={{ marginLeft: '10px', padding: '6px 20px' }} onClick={() => clickChangeMenu('taikhoan')}>Quay lại</button>
                </div>
            </form>
        </div>
    );
};

export default AdminAccountEditPage;
